<template>
  <VModal
      :title="room.number ? 'ویرایش اتاق ' + room.number : 'ایجاد اتاق'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="_method" value="PUT" v-if="room.number">

      <div class="mt-5">
        <label>شماره اتاق</label>
        <VInput type="number" name="number" :value="room.number" placeholder="شماره اتاق"  class="mt-4" required/>
      </div>

      <div class="mt-5">
        <label>ظرفیت</label>
        <VInput type="number" name="capacity" :value="room.capacity" placeholder="ظرفیت اتاق" class="mt-4" required/>
      </div>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت اتاق</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن اتاق، اتاق نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="room.active"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import {createRoom, updateRoom} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";

export default {
  name: "ModalRoom",
  components: {VLoadingScreen, VAlert, VButton, VSwitch, VInput, VModal},
  props: {
    show: Boolean,
    room: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: 1,
      loading: false,
      errors: [],
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let room = new FormData(this.$refs.form)
      room.append('active', this.active)

      if (this.room.number) {
        this.updateRoom(room)
      } else {
        this.createRoom(room)
      }
    },
    updateRoom(room) {
      updateRoom(this.room.id, room)
          .then(resp => {
            this.$emit('edited', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
    createRoom(room) {
      createRoom(room)
          .then(resp => {
            this.$emit('created', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    }
  }

}
</script>

<style scoped>

</style>